interface DashSegmentedControlOption<T extends string> {
  value: T;
  label: string;
  icon?: React.ReactNode;
}

interface DashSegmentedControlProps<T extends string> {
  options: DashSegmentedControlOption<T>[];
  value: T;
  onChange: (value: T) => void;
  fullWidth?: boolean;
}

function DashSegmentedControl<T extends string>({
  options,
  value,
  onChange,
  fullWidth = false,
}: DashSegmentedControlProps<T>) {
  return (
    <div
      className="d-flex"
      style={{
        border: "1px solid var(--dash-border)",
        borderRadius: 8,
        overflow: "hidden",
        width: fullWidth ? "100%" : undefined,
      }}
    >
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => onChange(opt.value)}
          style={{
            border: "none",
            flex: fullWidth ? 1 : undefined,
            padding: "0.4rem 0.9rem",
            fontFamily: "var(--dash-font-body)",
            fontSize: "0.8125rem",
            fontWeight: 600,
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "0.35rem",
            whiteSpace: "nowrap",
            background: value === opt.value ? "var(--dash-accent)" : "transparent",
            color: value === opt.value ? "#fff" : "var(--dash-muted)",
            transition: "background 0.15s ease, color 0.15s ease",
          }}
        >
          {opt.icon}
          {opt.label}
        </button>
      ))}
    </div>
  );
}

export default DashSegmentedControl;
